export const platformVersion = '^19.0.1';
